export default "__VITE_ASSET__CmRWTeJS__"